import App from '../../layout/App';
import { MenuContent,  Container, BoxButtom, SubTitle, Pagination } from '../../styles/styles'
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../Components/button';
import { useEffect, useState } from 'react';
import Loading from '../../Components/Loading'
import api from '../../utils/api'
import './styles.css';
import MessageTitle from '../../Components/MessageTitle'


function Vincular() {
  const [removeLoading , setRemoveLoading] = useState(false)
  const [disciplinas, setDisciplinas] = useState([])
  const [professores, setProfessores] = useState([])
  const [turma , setTurma] = useState([])
 const navigation = useNavigate()
  const teste = disciplinas

   function Salvar(){
    setRemoveLoading(false)
    if(disciplinas.length===0){
    navigation('/turma/pesquisar' , {replace:true})
  }
  else{
    api.put('/teach/professional', disciplinas).then((response) => {
    
      setRemoveLoading(true)
      navigation('/turma/pesquisar' , {replace:true})
    }).catch((err) => {
    
      setRemoveLoading(true)
    })
 }

  }

  useEffect(() => {
    
    const data = sessionStorage.getItem('inep')
    const codeTurma = sessionStorage.getItem('TurmaSelecionada')
    setTurma(JSON.parse(sessionStorage.getItem('TurmaEditar'))??'')
    api.get("professional/list/teach/" + data).then((response) => {
      setRemoveLoading(true)
      
      setProfessores(response.data)
    })

    api.get("teach/list/" + codeTurma).then((response) => {
      setDisciplinas(response.data)
    })

    setRemoveLoading(true)
  }, [])

  function AddProfessor(idDisciplina, professor, e) {
  
    let aux = teste.map((item) => {
      if (item.code_discipline === idDisciplina) {
        let test = item
        test.code_person_system_professional = professor
        return test
      }
      return item
    })
    setDisciplinas(aux)
    
  }

  return (
    <>
    { !removeLoading && <Loading/>}
    <App>
      <Container>
        <MenuContent>
      <div>
      TURMA - {turma.name}
          <SubTitle>Vincular Profissional e Disciplina</SubTitle>
      </div>
      <div>
          <Pagination>
          página 2/2
          </Pagination>
         </div>
        </MenuContent>
       
        <div className='container'>
        { !Array.isArray(disciplinas) || disciplinas?.length === 0? <MessageTitle message={"Não existe disciplinas para Vincular"}/>:
          <div className='box-grid'>
         {disciplinas.map((item, index) => {
              return (
                <div key={index} className="card-disciplina">
                  <p className='info-disciplina' >{item.discipline_name}:</p>
                  <div >
                    <select className='select'
                      onChange={(e) => AddProfessor(item.code_discipline, e.target.value)}>
                      {professores.map((itemd, index) => {
                        return (
                          <option key={index} selected={itemd.code_person_system_professional === item.code_person_system_professional} value={itemd.code_person_system_professional} id={itemd.id}>{itemd.name}</option>
                        )
                      })}
                    </select>
                  </div>
                </div>
              )
            })}
          </div>
}
        </div>
        <BoxButtom className='footer'>
          <Link to={'/turma/editar'}>
              <div>
                <Button title="Voltar" style={{ backgroundColor: 'red', width: '120px', height: '40px', marginTop: '10px' }} />
              </div>
              </Link>
              <Button title="Salvar" type='submit' onClick={() => Salvar()} style={{ backgroundColor: 'green', width: '120px', height: '40px', marginTop: '10px' }} />
            </BoxButtom>
      </Container>
    </App>
    </>
  )
}
export default Vincular;